/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-11 16:14:40
 * @LastEditTime: 2024-04-29 18:50:22
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\data.ts
 * @Description: 数据
 */
export const service = {
    login: '/login/userLogin',          // 普通登录
    selectLogin: '/portal/authentication/selectLogin',          // 选择登录(免token)
    smsLogin: '/login/userLogin',    // 短信登录
    sendLoginSmsCode: '/common/sendPhoneCheckCode', // 短信验证码
    logout: '/common/logout',        // 退出
    register: '/common/register',    // 注册
    checkPhone: 'common/checkPhone', // 校验手机号
    preResetPasswordByPhone: '/common/preResetPasswordByPhone',    // 手机验证身份
    resetPasswordByPhone: '/common/resetPasswordByPhone',    // 重置密码

    sendForgetOldPhoneSmsCode: '/portal/authentication/sendForgetOldPhoneSmsCode',    // 忘记旧手机号,发送新手机号的验证码
    verifyIdentity: '/portal/authentication/verifyIdentity',    // 校验身份信息

    getUserInfoForMobile: '/portal/homepage/getUserInfoForMobile',    // 获取登录信息

    addBindAccount: '/common/bandAccount',    // 添加绑定账户
}
